import React from 'react'

import {
  AlignItems,
  Body1,
  Box,
  Button,
  ButtonColorVariant,
  Color,
  Display,
  Display3,
  FlexDirection,
  FontWeight,
  Join,
  JustifyContent,
  Space,
  Visible,
} from '@gousto-internal/citrus-react'

import { ENDLESS_VARIETY } from './config'
import type { Recipe } from '@library/menu-service'
import { MenuCollections } from './MenuCollections'
import { RecipeCarousel } from './RecipeCarousel'

import { LandingPageContentSections, TrackingActions, trackCTAClick } from '../../tracking'

export type EndlessVarietySectionProps = {
  signupCTA: string
  onCTAClick: () => void
  recipes: Recipe[]
}

export const EndlessVarietySection = ({
  signupCTA,
  onCTAClick,
  recipes,
}: EndlessVarietySectionProps) => {
  const signupCTAClick = () => {
    onCTAClick()
    trackCTAClick(TrackingActions.CLICK_GET_STARTED, LandingPageContentSections.ENDLESS_VARIETY)
  }

  return (
    <section data-testid="endlessVariety">
      <Box bg={Color.NeutralGrey_50} paddingV={[14, 16]}>
        <Box
          paddingH={4}
          paddingV={4}
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          alignItems={[null, AlignItems.Center]}
        >
          <Join with={<Space size={4} />}>
            <Display3 color={Color.Primary_600}>
              {ENDLESS_VARIETY.heading}
              <sup style={{ fontWeight: FontWeight.Normal }}>*</sup>
            </Display3>
            <Body1>{ENDLESS_VARIETY.firstParagraph}</Body1>
            <MenuCollections />
          </Join>
        </Box>
        <RecipeCarousel recipes={recipes} />
        <Space size={6} />
        <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
          <Visible display={[Display.None, Display.Block]}>
            <Box minWidth="309px">
              <Button
                colorVariant={ButtonColorVariant.Primary}
                height="48px"
                onClick={signupCTAClick}
                width="100%"
              >
                {signupCTA}
              </Button>
            </Box>
          </Visible>
        </Box>
      </Box>
    </section>
  )
}
